<header class="account-menu-trigger-wrapper" [ngClass]="{ 'is-open': isOpen }">
  <button type="button" class="account-menu-trigger" (click)="toggleDropdown()">
    <div class="account-menu-trigger-contents">
      <div class="account-info">
        <span class="company-name">
          {{ companyName }}
        </span>

        <span class="account-email">
          {{ userEmail }}
        </span>
      </div>

      <app-icon class="chevron-icon" [icon]="chevronDownIcon"> </app-icon>
    </div>
  </button>
</header>
